import { BUILD_URL } from 'app/overview/config/configuration_tab/general/frontend_config/common/render_helpers';

interface TerrainLayerStatus {
    creation_date: string;
    folder_path: string;
    exists: boolean;
}

async function fetchTerrainLayerStatus(url: string): Promise<TerrainLayerStatus> {
    const response = await fetch(url, {
        mode: 'cors',
        credentials: 'omit',
    });

    if (!response.ok) {
        throw new Error('Failed to fetch URL data.');
    }

    const json = await response.json();
    return json;
}

export class TerrainService {
    private isValidTerrainLayer(value: unknown): value is TerrainLayerStatus {
        return (value as TerrainLayerStatus).exists;
    }

    public async getTerrainLayerCreationDate(url: string): Promise<string> {
        // take the custom url from IMS and replace tilesets with tileset_creation_date
        const layer_creation_date_url = BUILD_URL(url).replace('tilesets', 'tileset_creation_date');

        try {
            const terrainLayerStatus = await fetchTerrainLayerStatus(layer_creation_date_url);

            // get browser timezone
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // convert UTC terrain creation date time to browser timezone
            const terrain_creation_date_time_browser_timezone = new Date(
                terrainLayerStatus.creation_date,
            ).toLocaleString('en-US', { timeZone: timezone });

            if (this.isValidTerrainLayer(terrainLayerStatus)) {
                return `Terrain uploaded on ${terrain_creation_date_time_browser_timezone}`;
            } else {
                return 'Local Terrain Layer URL does not exist';
            }
        } catch (error) {
            return 'Failed to fetch data from Custom URL';
        }
    }
}
